import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'

export const getEstadosClientesIPS = async () => {
    const respuesta = PrivateInterceptor('Global/Status/CustomerIPS', 'GET')
    return respuesta
}

export const getEstadosCategory = async (StatusCategory) => {
    const respuesta = PrivateInterceptor(`Base/Global/Status/StatusCategory/${StatusCategory}`, 'GET');
    return respuesta;
}


export const getEstadosCategoryIPS = async (StatusCategory) => {
    const respuesta = PrivateInterceptor(`Base/Global/Status/StatusCategory/IPS/${StatusCategory}`, 'GET');
    return respuesta;
}

export const getEstadosCompletos = async () => {
    const respuesta = PrivateInterceptor(`status/Estados/Completos`, 'GET');
    return respuesta;
}

